export const NOTIFICATION_RETENTION_DAYS = 60;

export function parseNotificationDate(communicationDate: unknown): Date | null {
  if (communicationDate == null || communicationDate === "") {
    return null;
  }

  if (communicationDate instanceof Date) {
    return Number.isNaN(communicationDate.getTime()) ? null : communicationDate;
  }

  if (typeof communicationDate === "number") {
    const date = new Date(communicationDate);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  if (typeof communicationDate === "string") {
    const trimmed = communicationDate.trim();
    if (!trimmed) {
      return null;
    }

    let date = new Date(trimmed.includes("T") ? trimmed : trimmed.replace(" ", "T"));
    if (!Number.isNaN(date.getTime())) {
      return date;
    }

    const frenchDateMatch = trimmed.match(
      /^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{2}):(\d{2})(?::(\d{2}))?)?$/
    );
    if (frenchDateMatch) {
      const [, day, month, year, hours = "0", minutes = "0", seconds = "0"] =
        frenchDateMatch;
      date = new Date(
        Number(year),
        Number(month) - 1,
        Number(day),
        Number(hours),
        Number(minutes),
        Number(seconds)
      );
      if (!Number.isNaN(date.getTime())) {
        return date;
      }
    }
  }

  return null;
}

export function isNotificationWithinRetentionPeriod(
  communicationDate: unknown,
  retentionDays = NOTIFICATION_RETENTION_DAYS
): boolean {
  const date = parseNotificationDate(communicationDate);

  // Keep notifications when the date is missing or cannot be parsed.
  if (!date) {
    return true;
  }

  const cutoff = new Date();
  cutoff.setDate(cutoff.getDate() - retentionDays);
  cutoff.setHours(0, 0, 0, 0);

  return date.getTime() >= cutoff.getTime();
}
